/**
 * Rapor tipi -> ad eşlemesi.
 *
 * Ekranda hiçbir yerde "RT 13" gibi teknik kod görünmez; kullanıcı rakamın
 * hangi rapordan geldiğini adıyla okur. Kodun içinde rapor tipi hâlâ sayıdır
 * (servis onunla çalışıyor), çeviri yalnızca burada yapılır.
 *
 * short : dar alanlar için (KPI kutusu, huni satırı, tablo başlığı)
 * name  : kart alt başlıkları ve açıklama metinleri
 */
export const REPORTS = {
  1: { short: 'Kuyruk Genel', name: 'Kuyruk Genel Raporu' },
  2: { short: 'MT Kalite', name: 'MT Kalite Değerlendirme Raporu' },
  3: { short: 'Skill – Kuyruk', name: 'Skill Raporu – Kuyruk Bazında' },
  4: { short: 'Skill – Departman', name: 'Skill Raporu – Departman Bazında' },
  5: { short: 'Skill – Özel Grup', name: 'Skill Raporu – Özel Gruplama' },
  6: { short: 'Agent Genel', name: 'Agent Genel Raporu' },
  7: { short: 'Agent Skill & Dialer', name: 'Agent Skill ve Dialer Raporu' },
  8: { short: 'Outbound Detay', name: 'Agent Outbound Detay Raporu' },
  9: { short: 'Outbound Yurtdışı', name: 'Agent Outbound Yurtdışı Detay Raporu' },
  10: { short: 'OB Skill Arama', name: 'OB Skill Bazında Arama Raporu' },
  11: { short: 'OB Skill MT Arama', name: 'OB Skill Bazında MT Arama Raporu' },
  12: { short: 'Aranan Numara', name: 'Aranan Numara Bazında Çağrı Raporu' },
  13: { short: 'Kanal Detay', name: 'Kanal Bazında Gelen Arama Detay' },
  14: { short: 'Kanal Toplam', name: 'Kanal Bazında Gelen Arama Toplam' },
  15: { short: 'Interval Skill', name: 'Interval Skill Raporu' },
  16: { short: 'Interval Agent', name: 'Interval Agent Genel Raporu' },
  18: { short: 'Ipsos Skorları', name: 'Ipsos Company Bazında Skorlar' }
};

/** 13 -> "Kanal Bazında Gelen Arama Detay" */
export const reportName = (rt) => (REPORTS[rt] ? REPORTS[rt].name : `${rt} numaralı rapor`);

/** 13 -> "Kanal Detay" */
export const reportShort = (rt) => (REPORTS[rt] ? REPORTS[rt].short : `Rapor ${rt}`);

/** [13, 14] -> "Kanal Detay · Kanal Toplam" */
export const reportList = (rts, separator = ' · ') => rts.map(reportShort).join(separator);
